/* src/app/layout/layout.component.scss */
/*# sourceMappingURL=layout.component-K5367P6F.css.map */
